import React, { createContext, useContext, useEffect, useState } from "react";

const STR = {
    en: {
        nav: { home: "Home", services: "Services", packages: "Packages", quote: "Free Quote", contact: "Contact", book: "Book Now", tagline: "Premium Home & Facility Care" },
        hero: {
            eyebrow: "Registered business in Mauritius · BRN C22188258",
            line1: "Your home,",
            line2: "perfected.",
            sub: "Household maids, laundry, gardening, pest control, car valeting and building maintenance — delivered to one standard across Mauritius: premium.",
            cta1: "Book online",
            cta2: "Get a free quote",
            wa: "Chat on WhatsApp",
            chip1: "We guarantee a premium service",
            chip2: "Full & Half packages",
            badge: "Registered business",
            stat1: "6 expert services",
            stat2: "Full & Half packages",
            stat3: "Island-wide service"
        },
        marquee: ["HOUSEHOLD MAID", "LAUNDRY", "GARDENING", "PEST CONTROL", "CAR VALETING", "BUILDING MAINTENANCE", "MAURITIUS"],
        services: {
            eyebrow: "What we do",
            title: "Six services. One premium standard.",
            sub: "Every visit is planned, staffed and checked — so you never have to chase quality again.",
            from: "From",
            explore: "Explore",
            packagesNote: "Full & Half packages"
        },
        guarantee: {
            eyebrow: "Our promise",
            title: "We guarantee a premium service.",
            text: "Vetted and trained teams, quality-checked visits, and a registered business behind every booking. If a visit doesn't meet our standard, we come back — free.",
            points: ["Trained, background-checked staff", "Quality check after every visit", "Registered business · BRN C22188258", "Transparent prices, no hidden fees"]
        },
        compare: {
            eyebrow: "Full vs Half",
            title: "Two packages. Zero surprises.",
            sub: "Choose Full when you want everything handled — materials, detergents and equipment included. Choose Half when you prefer to supply your own.",
            full: "Full Package",
            half: "Half Package",
            fullDesc: "With materials & detergents",
            halfDesc: "Without materials — our labour & expertise only",
            view: "See the full comparison table",
            per: "per service",
            includes: "What's included",
            inc1: "Professional labour & expertise",
            inc1f: "Materials, detergents & equipment",
            inc1h: "You supply materials",
            inc2: "Quality check & follow-up"
        },
        how: {
            eyebrow: "How it works",
            title: "Booked in minutes, confirmed on WhatsApp",
            s1t: "Pick service & package", s1d: "Choose from six expert services, Full or Half package, in the online booking flow.",
            s2t: "Choose date & time", s2d: "Pick the slot that suits you and tell us where we should come.",
            s3t: "Confirm on WhatsApp", s3d: "Your booking summary opens in WhatsApp — one tap sends it straight to our team."
        },
        testimonials: {
            eyebrow: "Customers",
            title: "Loved across the island",
            sampleNote: "Sample reviews for illustration — our real customers say it best.",
            name: "Name"
        },
        faq: {
            eyebrow: "FAQ",
            title: "Questions, answered",
            items: [
                { q: "What areas of Mauritius do you serve?", a: "We serve the whole island from our base at Avenue Bouton D'Or, Highland Rose — homes, buildings, offices and agricultural land." },
                { q: "What is the difference between the Full and Half package?", a: "The Full Package includes all materials, detergents and equipment — we bring everything. The Half Package covers our labour and expertise while you supply the materials." },
                { q: "Are you a registered business?", a: "Yes. X Terminate Ltd is a registered business in Mauritius under BRN C22188258. You always know who is entering your home." },
                { q: "How do I book a service?", a: "Use the online booking page — pick your service, package, date and time, then confirm the booking on WhatsApp. You can also call +230 5920 0029." },
                { q: "Do you offer contracts for buildings and businesses?", a: "Yes. Scheduled maintenance, building upkeep and pest control contracts are available. Request a free quote and we will tailor it." },
                { q: "What if it rains on my gardening day?", a: "We reschedule free of charge. Your booking simply moves to the next convenient slot." }
            ]
        },
        cta: { title: "Ready for a spotless week?", sub: "Book online in two minutes or tell us exactly what you need — we reply fast on WhatsApp.", b1: "Book a service", b2: "Request a quote" },
        footer: {
            services: "Services", company: "Company", contact: "Contact",
            about: "Premium home and facility care, delivered island-wide by a registered Mauritian business.",
            registered: "Registered business in Mauritius",
            brn: "BRN C22188258",
            address: "Avenue Bouton D'Or, Highland Rose, Mauritius",
            rights: "All rights reserved.",
            packages: "Packages & Prices", faq: "FAQ", quote: "Free Quote", admin: "Admin"
        },
        booking: {
            title: "Book a service", sub: "Four quick steps — we confirm everything on WhatsApp.",
            step1: "Service", step2: "Package", step3: "Date & time", step4: "Your details",
            next: "Continue", back: "Back",
            choosePackage: "Choose your package",
            full: "Full Package", half: "Half Package",
            fullDesc: "Materials & detergents included — we bring everything",
            halfDesc: "Our labour & expertise only — you supply materials",
            pickDate: "Pick a date", pickTime: "Pick a time",
            name: "Full name", phone: "Phone number", email: "Email (optional)",
            address: "Address where we should come", notes: "Notes (optional)",
            namePh: "e.g. Marie-Christine Petit", phonePh: "+230 …", emailPh: "you@email.mu",
            addressPh: "Street, locality, e.g. Highland Rose, Curepipe",
            notesPh: "Gate code, pet at home, anything we should know…",
            review: "Review & confirm",
            reviewSub: "Check your booking, then confirm it on WhatsApp.",
            confirm: "Save & confirm on WhatsApp",
            required: "Please complete this step first.",
            done: "Booking saved!",
            doneSub: "One more tap — send us the summary on WhatsApp so we can lock your slot.",
            waSend: "Send summary on WhatsApp",
            newBooking: "Make another booking",
            callUs: "Or call us directly",
            summary: "Booking summary"
        },
        quote: {
            title: "Request a free quote", sub: "Tell us what you need — we reply fast, usually the same day.",
            name: "Full name", phone: "Phone number", email: "Email (optional)",
            service: "Which service?", servicePh: "e.g. Pest control for a warehouse",
            message: "Describe your request", messagePh: "What, where, how big, how often…",
            submit: "Send my request",
            done: "Request received!",
            doneSub: "We will get back to you shortly. Want a faster answer? WhatsApp us.",
            wa: "Continue on WhatsApp"
        },
        waMsg: {
            bookingEn: (s) => `Hello X Terminate! I would like to book:\n\n• Service: ${s.service}\n• Package: ${s.pkg}\n• Date: ${s.date}\n• Time: ${s.time}\n• Name: ${s.name}\n• Phone: ${s.phone}\n• Address: ${s.address}${s.notes ? `\n• Notes: ${s.notes}` : ""}\n\nSent from the website`,
            bookingFr: (s) => `Bonjour X Terminate ! Je souhaite réserver :\n\n• Service : ${s.service}\n• Forfait : ${s.pkg}\n• Date : ${s.date}\n• Heure : ${s.time}\n• Nom : ${s.name}\n• Téléphone : ${s.phone}\n• Adresse : ${s.address}${s.notes ? `\n• Remarques : ${s.notes}` : ""}\n\nEnvoyé depuis le site web`,
            quoteEn: (s) => `Hello X Terminate! Quote request:\n\n• Name: ${s.name}\n• Phone: ${s.phone}\n• Service: ${s.service}\n• Details: ${s.message}\n\nSent from the website`,
            quoteFr: (s) => `Bonjour X Terminate ! Demande de devis :\n\n• Nom : ${s.name}\n• Téléphone : ${s.phone}\n• Service : ${s.service}\n• Détails : ${s.message}\n\nEnvoyé depuis le site web`,
            simple: { en: "Hello X Terminate! I'd like to know more about your services.", fr: "Bonjour X Terminate ! J'aimerais en savoir plus sur vos services." }
        },
        admin: {
            title: "Admin dashboard", sub: "Bookings, quote requests and prices — no login required, keep this link private.",
            tabs: { bookings: "Bookings", quotes: "Quotes", prices: "Prices" },
            none: "Nothing here yet.",
            col: { customer: "Customer", service: "Service", when: "When", address: "Address", contact: "Contact", status: "Status", full: "Full (Rs)", half: "Half (Rs)", save: "Save", saved: "Saved" },
            status: { new: "New", confirmed: "Confirmed", done: "Done", cancelled: "Cancelled", sent: "Sent", won: "Won", closed: "Closed" }
        },
        common: { loading: "Loading…", error: "Something went wrong — please try again.", book: "Book now", from: "From", learn: "Learn more", whatsapp: "WhatsApp", call: "Call us" }
    },
    fr: {
        nav: { home: "Accueil", services: "Services", packages: "Forfaits", quote: "Devis gratuit", contact: "Contact", book: "Réserver", tagline: "Entretien premium maison & entreprises" },
        hero: {
            eyebrow: "Entreprise enregistrée à Maurice · BRN C22188258",
            line1: "Votre maison,",
            line2: "parfaite.",
            sub: "Femmes de ménage, lessive, jardinage, lutte antiparasitaire, lavage auto et entretien de bâtiments — partout à Maurice, selon une seule norme : premium.",
            cta1: "Réserver en ligne",
            cta2: "Devis gratuit",
            wa: "Discuter sur WhatsApp",
            chip1: "Nous garantissons un service premium",
            chip2: "Forfaits Complet & Demi",
            badge: "Entreprise enregistrée",
            stat1: "6 services experts",
            stat2: "Forfaits Complet & Demi",
            stat3: "Service sur toute l'île"
        },
        marquee: ["FEMME DE MÉNAGE", "LESSIVE", "JARDINAGE", "ANTI-NUISIBLES", "LAVAGE AUTO", "ENTRETIEN DE BÂTIMENTS", "MAURICE"],
        services: {
            eyebrow: "Nos services",
            title: "Six services. Une norme premium.",
            sub: "Chaque visite est planifiée, dotée en personnel et contrôlée — vous n'aurez plus jamais à courir après la qualité.",
            from: "Dès",
            explore: "Découvrir",
            packagesNote: "Forfaits Complet & Demi"
        },
        guarantee: {
            eyebrow: "Notre promesse",
            title: "Nous garantissons un service premium.",
            text: "Des équipes vérifiées et formées, des visites contrôlées, et une entreprise enregistrée derrière chaque réservation. Si une visite ne respecte pas notre norme, nous revenons — gratuitement.",
            points: ["Personnel formé et vérifié", "Contrôle qualité après chaque visite", "Entreprise enregistrée · BRN C22188258", "Prix transparents, sans frais cachés"]
        },
        compare: {
            eyebrow: "Complet vs Demi",
            title: "Deux forfaits. Zéro surprise.",
            sub: "Choisissez le Complet quand vous voulez tout confier — matériaux, détergents et équipement inclus. Choisissez le Demi si vous préférez fournir vos propres produits.",
            full: "Pack Complet",
            half: "Pack Demi",
            fullDesc: "Avec matériaux & détergents",
            halfDesc: "Sans matériaux — notre main-d'œuvre & expertise",
            view: "Voir le tableau comparatif complet",
            per: "par service",
            includes: "Ce qui est inclus",
            inc1: "Main-d'œuvre & expertise professionnelles",
            inc1f: "Matériaux, détergents & équipement",
            inc1h: "Vous fournissez les matériaux",
            inc2: "Contrôle qualité & suivi"
        },
        how: {
            eyebrow: "Comment ça marche",
            title: "Réservé en quelques minutes, confirmé sur WhatsApp",
            s1t: "Choisissez service & forfait", s1d: "Parmi six services experts, forfait Complet ou Demi, dans le parcours de réservation en ligne.",
            s2t: "Choisissez date & heure", s2d: "Choisissez le créneau qui vous convient et indiquez-nous où venir.",
            s3t: "Confirmez sur WhatsApp", s3d: "Le récapitulatif de votre réservation s'ouvre dans WhatsApp — un appui et c'est envoyé à notre équipe."
        },
        testimonials: {
            eyebrow: "Clients",
            title: "Appréciés sur toute l'île",
            sampleNote: "Avis d'exemple à titre d'illustration — nos vrais clients en disent le plus long.",
            name: "Nom"
        },
        faq: {
            eyebrow: "FAQ",
            title: "Vos questions, nos réponses",
            items: [
                { q: "Quelles régions de Maurice desservez-vous ?", a: "Nous couvrons toute l'île depuis notre base à l'Avenue Bouton D'Or, Highland Rose — maisons, immeubles, bureaux et terres agricoles." },
                { q: "Quelle est la différence entre le Pack Complet et le Pack Demi ?", a: "Le Pack Complet inclut tous les matériaux, détergents et l'équipement — nous apportons tout. Le Pack Demi couvre notre main-d'œuvre et notre expertise, vous fournissez les matériaux." },
                { q: "Êtes-vous une entreprise enregistrée ?", a: "Oui. X Terminate Ltd est une entreprise enregistrée à Maurice sous le BRN C22188258. Vous savez toujours qui entre chez vous." },
                { q: "Comment réserver un service ?", a: "Utilisez la page de réservation en ligne — choisissez votre service, forfait, date et heure, puis confirmez sur WhatsApp. Vous pouvez aussi appeler le +230 5920 0029." },
                { q: "Proposez-vous des contrats pour immeubles et entreprises ?", a: "Oui. Entretien régulier, contrats de bâtiments et traitements antiparasitaires programmés sont disponibles. Demandez un devis gratuit, nous l'adapterons." },
                { q: "Et s'il pleut le jour du jardinage ?", a: "Nous reprogrammons gratuitement. Votre réservation passe simplement au créneau suivant qui vous convient." }
            ]
        },
        cta: { title: "Prêt pour une semaine impeccable ?", sub: "Réservez en ligne en deux minutes ou dites-nous exactement ce qu'il vous faut — nous répondons vite sur WhatsApp.", b1: "Réserver un service", b2: "Demander un devis" },
        footer: {
            services: "Services", company: "Entreprise", contact: "Contact",
            about: "Entretien premium de maisons et d'entreprises, sur toute l'île, par une entreprise mauricienne enregistrée.",
            registered: "Entreprise enregistrée à Maurice",
            brn: "BRN C22188258",
            address: "Avenue Bouton D'Or, Highland Rose, Maurice",
            rights: "Tous droits réservés.",
            packages: "Forfaits & Prix", faq: "FAQ", quote: "Devis gratuit", admin: "Admin"
        },
        booking: {
            title: "Réserver un service", sub: "Quatre étapes rapides — nous confirmons tout sur WhatsApp.",
            step1: "Service", step2: "Forfait", step3: "Date & heure", step4: "Vos détails",
            next: "Continuer", back: "Retour",
            choosePackage: "Choisissez votre forfait",
            full: "Pack Complet", half: "Pack Demi",
            fullDesc: "Matériaux & détergents inclus — nous apportons tout",
            halfDesc: "Notre main-d'œuvre & expertise — vous fournissez les matériaux",
            pickDate: "Choisissez une date", pickTime: "Choisissez une heure",
            name: "Nom complet", phone: "Numéro de téléphone", email: "Email (optionnel)",
            address: "Adresse où nous devons venir", notes: "Remarques (optionnel)",
            namePh: "ex. Marie-Christine Petit", phonePh: "+230 …", emailPh: "vous@email.mu",
            addressPh: "Rue, localité, ex. Highland Rose, Curepipe",
            notesPh: "Code du portail, animal à la maison, tout ce qu'il faut savoir…",
            review: "Vérifier & confirmer",
            reviewSub: "Vérifiez votre réservation, puis confirmez-la sur WhatsApp.",
            confirm: "Enregistrer & confirmer sur WhatsApp",
            required: "Veuillez d'abord compléter cette étape.",
            done: "Réservation enregistrée !",
            doneSub: "Un dernier appui — envoyez-nous le récapitulatif sur WhatsApp pour bloquer votre créneau.",
            waSend: "Envoyer le récapitulatif sur WhatsApp",
            newBooking: "Faire une autre réservation",
            callUs: "Ou appelez-nous directement",
            summary: "Récapitulatif de la réservation"
        },
        quote: {
            title: "Demander un devis gratuit", sub: "Dites-nous ce qu'il vous faut — nous répondons vite, souvent le jour même.",
            name: "Nom complet", phone: "Numéro de téléphone", email: "Email (optionnel)",
            service: "Quel service ?", servicePh: "ex. Lutte antiparasitaire pour un entrepôt",
            message: "Décrivez votre demande", messagePh: "Quoi, où, quelle ampleur, quelle fréquence…",
            submit: "Envoyer ma demande",
            done: "Demande reçue !",
            doneSub: "Nous reviendrons vers vous rapidement. Vous voulez une réponse plus rapide ? WhatsApp.",
            wa: "Continuer sur WhatsApp"
        },
        waMsg: {
            bookingEn: null, bookingFr: null,
            simple: { en: "Bonjour X Terminate ! J'aimerais en savoir plus sur vos services.", fr: "Bonjour X Terminate ! J'aimerais en savoir plus sur vos services." }
        },
        admin: {
            title: "Tableau de bord admin", sub: "Réservations, demandes de devis et prix — sans connexion, gardez ce lien privé.",
            tabs: { bookings: "Réservations", quotes: "Devis", prices: "Prix" },
            none: "Rien pour le moment.",
            col: { customer: "Client", service: "Service", when: "Quand", address: "Adresse", contact: "Contact", status: "Statut", full: "Complet (Rs)", half: "Demi (Rs)", save: "Enregistrer", saved: "Enregistré" },
            status: { new: "Nouvelle", confirmed: "Confirmée", done: "Terminée", cancelled: "Annulée", sent: "Envoyé", won: "Gagné", closed: "Fermé" }
        },
        common: { loading: "Chargement…", error: "Une erreur est survenue — veuillez réessayer.", book: "Réserver", from: "Dès", learn: "En savoir plus", whatsapp: "WhatsApp", call: "Appelez-nous" }
    }
};

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => localStorage.getItem("xt-lang") || "en");
    const setLang = (l) => { localStorage.setItem("xt-lang", l); setLangState(l); };
    useEffect(() => { document.documentElement.lang = lang; }, [lang]);
    const t = STR[lang] || STR.en;
    return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
    const ctx = useContext(LangCtx);
    if (!ctx) throw new Error("useLang outside provider");
    return ctx;
};

// WhatsApp message builders are language-dependent functions, kept out of the dict
export const waBookingText = (lang, s) =>
    lang === "fr"
        ? `Bonjour X Terminate ! Je souhaite réserver :\n\n• Service : ${s.service}\n• Forfait : ${s.pkg}\n• Date : ${s.date}\n• Heure : ${s.time}\n• Nom : ${s.name}\n• Téléphone : ${s.phone}\n• Adresse : ${s.address}${s.notes ? `\n• Remarques : ${s.notes}` : ""}\n\nEnvoyé depuis le site web`
        : `Hello X Terminate! I would like to book:\n\n• Service: ${s.service}\n• Package: ${s.pkg}\n• Date: ${s.date}\n• Time: ${s.time}\n• Name: ${s.name}\n• Phone: ${s.phone}\n• Address: ${s.address}${s.notes ? `\n• Notes: ${s.notes}` : ""}\n\nSent from the website`;

export const waQuoteText = (lang, s) =>
    lang === "fr"
        ? `Bonjour X Terminate ! Demande de devis :\n\n• Nom : ${s.name}\n• Téléphone : ${s.phone}\n• Service : ${s.service}\n• Détails : ${s.message}\n\nEnvoyé depuis le site web`
        : `Hello X Terminate! Quote request:\n\n• Name: ${s.name}\n• Phone: ${s.phone}\n• Service: ${s.service}\n• Details: ${s.message}\n\nSent from the website`;

export default STR;